module.exports = __webpack_public_path__ + "document.svg?2a0fe20c722420a4a90924ea77268749";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/document.svg
// module id = 147
// module chunks = 0